function shouldEnableRegex() {
    return true
}
function getMarketLangFromUrl() {
  const path = window.location.pathname;
  const segments = path.split('/').filter(Boolean); // removes empty items
  const hostname = window.location.hostname;

  let langMarket;

  const isATDomain = /^at\./.test(hostname);
  const isShopFritz = hostname === 'shop.fritz.com';
  const isAtFritz = hostname === 'at.fritz.com';
  const isRootFritz = hostname === 'fritz.com';            // NEW: bare fritz.com
  const isItTestFritz = hostname === 'it.test-fritz.com';  // earlier addition

  if (segments.length === 0) {
    // No prefix — root page
    if (isShopFritz || isRootFritz) {
      langMarket = 'de-de';
    } else if (isAtFritz || isATDomain) {
      langMarket = 'de-at';
    } else if (isItTestFritz) {
      langMarket = 'it-it';
    } else {
      langMarket = 'de-de';
    }
  } else {
    const firstSegment = segments[0].toLowerCase();

    if (/^[a-z]{2}-[a-z]{2}$/.test(firstSegment)) {
      // Matches pattern like "fr-fr", "en-nl"
      langMarket = firstSegment;
    } else if (/^[a-z]{2}$/.test(firstSegment)) {
      // Single language code like "en"
      const langCode = firstSegment;
      if (isShopFritz || isRootFritz) {
        // fritz.com/en or shop.fritz.com/en => en-de
        langMarket = `${langCode}-de`;
      } else if (isAtFritz || isATDomain) {
        // at.fritz.com/en or at.* => en-at
        langMarket = `${langCode}-at`;
      } else if (isItTestFritz) {
        // it.test-fritz.com/en => en-it
        langMarket = `${langCode}-it`;
      } else {
        // default: language-de
        langMarket = `${langCode}-de`;
      }
    } else {
      // Unexpected format — fallback by host
      if (isShopFritz || isRootFritz) {
        langMarket = 'de-de';
      } else if (isAtFritz || isATDomain) {
        langMarket = 'de-at';
      } else if (isItTestFritz) {
        langMarket = 'it-it';
      } else {
        langMarket = 'de-de';
      }
    }
  }

  return langMarket;
}